export default {
  data() {
    return {
      s_colors: (value) => getComputedStyle(document.body).getPropertyValue(value),
    };
  },
};
